import type {
  Identification,
  IdentificationQuery,
} from '@festina/legalentity-general-types/legalentity'

export function createIdentification(
  entityId: Identification['identity'],
): Identification {
  return {
    _type: 'Identification',
    identity: entityId,
  } as Identification
}

export function createIdentificationQuery(
  entityIds: Identification['identity'][],
): IdentificationQuery | undefined {
  return entityIds.length
    ? {
        _type: 'IdentificationQuery',
        identifications: entityIds.map(createIdentification),
      }
    : // This is needed to avoid the validation error `legalentity.query.noIdentifications`:
      // > The identification query needs at least a single identification.
      undefined
}
